import { useEffect, useRef } from 'react';

interface Callable {
    (...args: any[]): any;
}

export function useLatestCallbackRef<F extends Callable>(callback: F) {
    type Callback = (...args: Parameters<F>) => ReturnType<F>;

    const callbackRef = useRef<Callback>(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    return callbackRef;
}
